import React from "react"

type IconProps = React.SVGProps<SVGSVGElement>

const MealIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9 0C9.88885 0 10.5524 0.675019 10.756 1.50181C14.3624 2.28408 17.1141 5.4342 17.3373 9.39359C17.8971 9.74489 18.1748 10.4994 17.8817 11.1888C17.4137 12.2895 16.3692 12.9999 15.2153 13H2.7847C1.63079 12.9999 0.586325 12.2895 0.11829 11.1888C-0.174782 10.4994 0.102947 9.74489 0.662749 9.39359C0.885852 5.43452 3.63714 2.28439 7.24313 1.50181C7.44664 0.674916 8.11106 0 9 0ZM1.40011 10.6368C1.65344 11.1969 2.19161 11.5555 2.7847 11.5556H15.2153C15.8084 11.5555 16.3466 11.1969 16.5999 10.6368H1.40011ZM9 2.75723C8.64868 2.75723 8.30347 2.78317 7.96697 2.83341C4.82433 3.30279 2.37858 5.88483 2.06536 9.19235H15.9346C15.6214 5.88483 13.1757 3.30279 10.033 2.83341C9.69653 2.78317 9.35132 2.75723 9 2.75723Z"
      fill="currentColor"
    />
  </svg>
)

export default MealIcon
